function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { context } from "../components/wr-context";
import newError from "./errors";
import fetch from "isomorphic-unfetch";
var defaultHeaders = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache"
};
// Receiving these error messages should trigger a logout
var LOGOUT_ERROR_MESSAGES = [
    "Invalid token",
    "Authentication Error",
    "JWT_validation_reject_auth_before"
];
export function buildRequest(mapping) {
    var url = new URL(mapping.url);
    if (typeof mapping.query === "object") {
        Object.entries(mapping.query).forEach(function(param) {
            var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
            return url.searchParams.append(k, v);
        });
    } else if (typeof mapping.query === "string") {
        url = "".concat(url, "?").concat(mapping.query);
    }
    if (mapping.hasOwnProperty("headers")) {
        Object.entries(defaultHeaders).forEach(function(param) {
            var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
            var ref;
            if (!((ref = mapping.headers) === null || ref === void 0 ? void 0 : ref.hasOwnProperty(k))) {
                mapping.headers = _objectSpreadProps(_objectSpread({}, mapping.headers), _defineProperty({}, k, v));
            }
        });
    } else {
        mapping.headers = _objectSpread({}, defaultHeaders);
    }
    if (_instanceof(mapping === null || mapping === void 0 ? void 0 : mapping.body, window.FormData) && (mapping === null || mapping === void 0 ? void 0 : mapping.headers) && "Content-Type" in mapping.headers) {
        delete mapping.headers["Content-Type"];
    }
    var options = {
        method: mapping.method,
        cache: mapping.cache,
        headers: mapping.headers,
        credentials: mapping.credentials,
        redirect: mapping.redirect,
        mode: mapping.mode,
        body: mapping.body
    };
    if (!context.constants.requireAuth) {
        options.headers = _objectSpreadProps(_objectSpread({}, options.headers), {
            token: context.constants.token
        });
    }
    if (context.state.isLoggedIn && context.state.authorization) {
        options.headers = _objectSpreadProps(_objectSpread({}, options.headers), {
            Authorization: "Bearer ".concat(context.state.authorization)
        });
    }
    return new window.Request(url, options);
}
export function handleResponse(response) {
    if (response.headers.get("content-length") === "0" || response.status === 204) {
        return;
    }
    if (response.headers.get("content-type") === "application/octet-stream") {
        return response.blob();
    }
    var json = response.json();
    if (response.status >= 200 && response.status < 300) {
        return json;
    } else {
        return json.then(function(cause) {
            if (LOGOUT_ERROR_MESSAGES.includes(cause.errorMessage)) {
                context.actions.logout();
                context.history.replace("/");
            }
            return Promise.reject(newError(cause));
        });
    }
}
export default function request() {
    return _request.apply(this, arguments);
};
function _request() {
    _request = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var options, request, _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    request = buildRequest(options);
                    return _ctx.abrupt("return", fetch(request).then(handleResponse));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _request.apply(this, arguments);
}
